import _ from 'lodash';
import { mapGetters } from 'vuex';
import { initDycolor } from '~';
import { STATUSES } from '~/utils/constants';

initDycolor('campaign-status', require(`${process.env.DYCOLOR_REQUIRE}./CampaignStatus.scss`)); // eslint-disable-line

export default {
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    statusName() {
      if (!this.campaign) {
        return null;
      }

      let code = _.get(this, 'campaign.baseStatus.code', null);

      if (code === STATUSES.ONL && _.get(this, 'campaign.issues', []).filter(i => !i.finished_at).length) {
        code = `${code}-issues`;
      }

      return this.$t(`terms.statuses.${code}`);
    },
    activeIssues() {
      return _.get(this, 'campaign.issues', [])
        .filter(i => !i.finished_at)
        .map(i => i.name);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaign-status/CampaignStatus.js